export default [
  {
    path: '/assets/:key?',
    name: 'assetIndex',
    component: () => import('@/views/asset/AssetIndex.vue'),
    meta: {},
  },
];
